import { useParams, Link, Navigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ALL_POSTS } from "./posts/posts";
import { POST_CONTENT } from "./posts/content";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import PostTag from "../components/PostTag";
import styles from "./PostPage.module.css";

const mdComponents = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

export default function PostPage() {
  const { slug } = useParams();
  const post = ALL_POSTS.find((p) => p.slug === slug);
  const content = POST_CONTENT[slug];

  if (!post || !content) return <Navigate to="/writing" replace />;

  const nextPost = post.nextSlug
    ? ALL_POSTS.find((p) => p.slug === post.nextSlug)
    : null;

  return (
    <div className={styles.page}>
      <Nav theme="light" />
      <div className={styles.container}>
        <Link to="/writing" className={styles.back}>
          ← All writing
        </Link>
        <article>
          <header className={styles.header}>
            <div className={styles.tagRow}>
              {post.tags.map((t) => <PostTag key={t} tag={t} />)}
            </div>
            <h1 className={styles.title}>{post.title}</h1>
            <div className={styles.meta}>
              <span>{post.date}</span>
              <span>·</span>
              <span>{post.readTime} read</span>
            </div>
          </header>
          <div className={styles.body}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={mdComponents}>{content}</ReactMarkdown>
          </div>
        </article>
        {nextPost && (
          <div className={styles.nextRead}>
            <Link to="/writing" className={styles.nextReadBack}>← All writing</Link>
            <Link to={`/writing/${nextPost.slug}`} className={styles.nextReadNext}>
              <span className={styles.nextReadTitle}>{nextPost.title}</span>
              <span className={styles.nextReadShort}>Next read</span>
              <span className={styles.nextReadArrow}>→</span>
            </Link>
          </div>
        )}
        <Footer theme="light" />
      </div>
    </div>
  );
}
